"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalSeparationSVGDraw = void 0;
const mithril_1 = require("../mithril");
const theme_1 = require("../theme");
const label_draw_svg_1 = require("./label.draw.svg");
const util_draw_svg_1 = require("./util.draw.svg");
class VerticalSeparationSVGDraw {
    static view(drawable, options) {
        if (!drawable.isVisible || !options.isVerticalSeparationEnabled) {
            return null;
        }
        const indexOffset = drawable.indexInGroupWithSameTopMarker() * theme_1.StyleConfig.STROKE_WIDTH * 4;
        return (0, mithril_1.m)('g', {
            id: `vertical-separation-${drawable.id}`,
        }, [
            label_draw_svg_1.LabelSVGDraw.view(drawable.label, options),
            // Draw the vertical separation clearance line (vertical line between the top and bottom markers).
            // If the label is on the left side, draw this line on the left side of the pole.
            // Otherwise, draw it on the right side of the pole.
            util_draw_svg_1.SVGUtil.DrawLineBordered({
                x: drawable.label.isOnLeftSide()
                    ? drawable.topMarker.x - options.draw.state.markerOffsetWidth + indexOffset
                    : drawable.topMarker.x + options.draw.state.markerOffsetWidth - indexOffset,
                y: drawable.topMarker.y,
            }, {
                x: drawable.label.isOnLeftSide()
                    ? drawable.bottomMarker.x - options.draw.state.markerOffsetWidth + indexOffset
                    : drawable.bottomMarker.x + options.draw.state.markerOffsetWidth - indexOffset,
                y: drawable.bottomMarker.y,
            }, options.scale, drawable.clearanceThresholdInMeters ? (drawable.isInClearance ? 'lime' : 'red') : theme_1.StyleConfig.STROKE_SECONDARY),
        ]);
    }
}
exports.VerticalSeparationSVGDraw = VerticalSeparationSVGDraw;
//# sourceMappingURL=vertical.separation.draw.svg.js.map